import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: "cliente",
        data: { breadcrumb: "Clientes" },
        loadChildren: () => import("./cliente/cliente.app.module").then((m) => m.ClienteAppModule),
      },
      {
        path: "grupo",
        data: { breadcrumb: "Grupos" },
        loadChildren: () => import("./grupo/grupo.app.module").then((m) => m.GrupoAppModule),
      },
      {
        path: "indicador-cliente",
        data: { breadcrumb: "Indicadores Clientes" },
        loadChildren: () => import("./indicador-cliente/indicador-cliente.app.module").then((m) => m.IndicadorClienteAppModule),
      },
      {
        path: "fabricante",
        data: { breadcrumb: "Fabricantes" },
        loadChildren: () => import("./fabricante/fabricante.app.module").then((m) => m.FabricanteAppModule),
      },
      {
        path: "contrato",
        data: { breadcrumb: "Contratos" },
        loadChildren: () => import("./contrato/contrato.app.module").then((m) => m.ContratoAppModule),
      },
      {
        path: "fornecedor",
        data: { breadcrumb: "Fornecedores" },
        loadChildren: () => import("./fornecedor/fornecedor.app.module").then((m) => m.FornecedorAppModule),
      },
      {
        path: "item-produto",
        data: { breadcrumb: "Produtos" },
        loadChildren: () => import("./item-produto/item-produto.app.module").then((m) => m.ItemProdutoAppModule),
      },
      {
        path: "entrada",
        data: { breadcrumb: "Entradas" },
        loadChildren: () => import("./entrada/entrada.app.module").then((m) => m.EntradaAppModule),
      },
      {
        path: "conta",
        data: { breadcrumb: "Contas" },
        loadChildren: () => import("./conta/conta.app.module").then((m) => m.ContaAppModule),
      },
      {
        path: "operacao-financeira",
        data: { breadcrumb: "Operações Financeiras" },
        loadChildren: () => import("./operacao-financeira/operacao-financeira.app.module").then((m) => m.OperacaoFinanceiraAppModule),
      },
      {
        path: "tipo-pagamento",
        data: { breadcrumb: "Tipos Pagamentos" },
        loadChildren: () => import("./tipo-pagamento/tipo-pagamento.app.module").then((m) => m.TipoPagamentoAppModule),
      },
      {
        path: "item-servico",
        data: { breadcrumb: "Serviços" },
        loadChildren: () => import("./item-servico/item-servico.app.module").then((m) => m.ItemServicoAppModule),
      },
      {
        path: "dashboard",
        data: { breadcrumb: "Dashboard" },
        loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashBoardModule),
      },
      {
        path: "profissional",
        data: { breadcrumb: "Profissionais" },
        loadChildren: () => import("./profissional/profissional.app.module").then((m) => m.ProfissionalAppModule),
      },
      {
        path: "agendamento-despesa",
        data: { breadcrumb: "Agendamento de Despesas" },
        loadChildren: () => import("./agendamento-despesa/agendamento-despesa.app.module").then((m) => m.AgendamentoDespesaAppModule),
      },
      {
        path: "pagamento-despesa",
        data: { breadcrumb: "Pagamento de Despesas" },
        loadChildren: () => import("./pagamento-despesa/pagamento-despesa.app.module").then((m) => m.PagamentoDespesaAppModule),
      },
      {
        path: "outras-receitas",
        data: { breadcrumb: "Outras Receitas" },
        loadChildren: () => import("./outras-receitas/outras-receitas.app.module").then((m) => m.OutrasReceitasAppModule),
      },
      {
        path: "dados-empresa",
        data: { breadcrumb: "Dados Empresa" },
        loadChildren: () => import("./dados-empresa/dados-empresa.module").then((m) => m.DadosEmpresaModule),
      },
      {
        path: "plano-conta-empresa",
        data: { breadcrumb: "Planos Contas Empresa" },
        loadChildren: () => import("./plano-contas-empresa/plano-contas-empresa.module").then((m) => m.PlanoContasEmpresaModule),
      },
      {
        path: "usuario-empresa",
        data: { breadcrumb: "Usuários Empresa" },
        loadChildren: () => import("./usuario-empresa/usuario-empresa.module").then((m) => m.UsuarioEmpresaModule),
      },
      {
        path: "adicionais-e-descontos",
        data: { breadcrumb: "Adicionais e Descontos" },
        loadChildren: () => import("./adicionais-e-descontos/adicionais-e-descontos.module").then((m) => m.AdicionaisEDescontosModule),
      },
      {
        path: "adiantamento",
        data: { breadcrumb: "Adiantamentos" },
        loadChildren: () => import("./adiantamento/adiantamento.module").then((m) => m.AdiantamentoModule),
      },
      {
        path: "consumo",
        data: { breadcrumb: "Consumos" },
        loadChildren: () => import("./consumo/consumo.module").then((m) => m.ConsumoModule),
      },
      {
        path: "orcamentos-e-pacotes",
        data: { breadcrumb: "Orçamentos e Pacotes" },
        loadChildren: () => import("./orcamentos-e-pacotes/orcamentos-e-pacotes.module").then((m) => m.OrcamentosEPacotesModule),
      },
      {
        path: "saida-estoque",
        data: { breadcrumb: "Saídas" },
        loadChildren: () => import("./saida-estoque/saida-estoque.module").then((m) => m.SaidaEstoqueModule),
      },
      {
        path: "suporte",
        data: { breadcrumb: "Suporte" },
        loadChildren: () => import("./chamado-empresa/chamado-empresa.module").then((m) => m.ChamadoEmpresaModule),
      },
      { path: "caixa", data: { breadcrumb: "Caixa" }, loadChildren: () => import("./caixa/caixa.module").then((m) => m.CaixaModule) },
      {
        path: "caixa-gerenciar",
        data: { breadcrumb: "Gerenciar Caixa" },
        loadChildren: () => import("./caixa-gerenciar/caixa-gerenciar.module").then((m) => m.CaixaGerenciarModule),
      },
      {
        path: "comanda",
        data: { breadcrumb: "Comanda" },
        loadChildren: () => import("./comanda/comanda.module").then((m) => m.ComandaModule),
      },
      { path: "agenda", data: { breadcrumb: "Agenda" }, loadChildren: () => import("./agenda/agenda.module").then((m) => m.AgendaModule) },
      {
        path: "conciliar-conta",
        data: { breadcrumb: "Conciliar Contas" },
        loadChildren: () => import("./conciliar-conta/conciliar-conta.module").then((m) => m.ConciliarContaModule),
      },
      {
        path: "central-cliente",
        data: { breadcrumb: "Central do Cliente" },
        loadChildren: () => import("./central-cliente/central-cliente.module").then((m) => m.CentralClienteModule),
      },
      {
        path: "anamnese-configuracao",
        data: { breadcrumb: "Configuração Anamnese" },
        loadChildren: () => import("./anamnese-configuracao/anamnese-configuracao.module").then((m) => m.AnamneseConfiguracaoModule),
      },
      {
        path: "comissao",
        data: { breadcrumb: "Comissões" },
        loadChildren: () => import("./comissao/comissao.module").then((m) => m.ComissaoModule),
      },
      {
        path: "lancamento-folha",
        data: { breadcrumb: "Lançamento Folha" },
        loadChildren: () => import("./lancamento-folha/lancamento-folha.module").then((m) => m.LancamentoFolhaModule),
      },
      {
        path: "pagamento-folha",
        data: { breadcrumb: "Pagamento Folha" },
        loadChildren: () => import("./pagamento-folha/pagamento-folha.module").then((m) => m.PagamentoFolhaModule),
      },
      {
        path: "configuracao-pix",
        data: { breadcrumb: "Configuração PIX" },
        loadChildren: () => import("./configuracao-pix/configuracao-pix.module").then((m) => m.ConfiguracaoPixModule),
      },
      {
        path: "direcionar-saida-caixa",
        data: { breadcrumb: "Direcionar Saída Caixa" },
        loadChildren: () => import("./gerenciar-saida-caixa/gerenciar-saida-caixa.module").then((m) => m.GerenciarSaidaCaixaModule),
      },
      {
        path: "patrimonio",
        data: { breadcrumb: "Patrimônio" },
        loadChildren: () => import("./patrimonio/patrimonio.module").then((m) => m.PatrimonioModule),
      },
      {
        path: "dre",
        data: { breadcrumb: "DRE" },
        loadChildren: () => import("./dre/dre.module").then((m) => m.DreModule),
      }
    ]),
  ],
  exports: [RouterModule],
})
export class AppsRoutingModule {}
